module.exports = __webpack_public_path__ + "static/media/Quick Quote.c3100b80.png";